import { LoginPage } from '@/features/auth';
import { useMaintenanceWindow } from '@/features/maintenance';

/**
 * The /login route: LoginPage with the maintenance state threaded in (Proweb-38 follow-up — provider
 * login is disabled while maintenance is in progress). Composed here because a feature never imports
 * another feature; layout is where auth and maintenance may meet.
 *
 * "In progress", not "announced": the lookup reports the current-OR-NEXT window, so gating on
 * `active` alone would lock providers out days early — and a weekly recurring window would disable
 * login permanently. The banner may announce the future; only the running window blocks login.
 */
export function LoginScreen(): React.JSX.Element {
  const { data } = useMaintenanceWindow();

  const inProgress =
    data?.active === true &&
    data.startsAt !== null &&
    data.endsAt !== null &&
    Date.parse(data.startsAt) <= Date.now() &&
    Date.now() < Date.parse(data.endsAt);

  return <LoginPage maintenanceActive={inProgress} />;
}
